import { render } from "./EmbedPages.vue?vue&type=template&id=275f8864&ts=true"
import script from "./EmbedPages.vue?vue&type=script&lang=ts"
export * from "./EmbedPages.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__